<template>
  <OpenListQuestionSetting v-if="isOpenListQuestionType" :question="question" />

  <TextQuestionSetting v-if="isTextQuestionType" :question="question" />
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import OpenListQuestionSetting from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/blocks/OpenListQuestion/OpenListQuestionSetting.vue";
import {questions, QuestionTypes} from "@/page/quiz/typeQuiz";
import TextQuestionSetting from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/blocks/TextQuestion/TextQuestionSetting.vue";

export default defineComponent({
  name: "QuestionSettingPart",

  components: {TextQuestionSetting, OpenListQuestionSetting},

  props: {
    question: {
      type: Object as PropType<questions | null>,
      default: null
    },

    questionIndex: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {};
  },

  computed: {
    questionType(): QuestionTypes {
      const questionType = this.question?.type as QuestionTypes;
      return questionType || "";
    },
    isOpenListQuestionType() {
      const questionTypes = [
        "checkbox",
        "checkbox-img",
        "radio",
        "radio-img"
      ] as QuestionTypes[];
      return questionTypes.includes(this.questionType);
    },
    isTextQuestionType() {
      const questionTypes = ["text", "textArea"] as QuestionTypes[];
      return questionTypes.includes(this.questionType);
    }
  },

  methods: {}
});
</script>
